import React, { useEffect, useState } from "react";
import {
  AddFlex,
  CustomInput,
  CustomText,
  CustomTextArea,
} from "../../reusableStyles";
import { Button, ConfigProvider, Segmented } from "antd";
import { primaryActionColor, primaryActionColorLight } from "../../constants";
import useDialogActionsHook from "../../CustomHooks.js/useDialogActionsHook";
import { Dialog } from "@mui/material";
import DialogWrapper from "../../DialogWrapper";
import AdvancedKeywordResponses from "./AdvancedKeywordResponses";
import { Segment } from "@mui/icons-material";
import { MessageOutlined, ProductOutlined } from "@ant-design/icons";
import ProductCataloguePopup from "./ProductCataloguePopup";
import { GetProductsCategoryWise } from "../../Api/ApiEndPoints";
import { useSelector } from "react-redux";
import { callNonStoreApi } from "../../NonStoreApis";
import { isArrayNullOrUndefined } from "../../utils";

function InstaCommentToDMAutomationMessage({
  isEdit,
  disabled,
  automationData,
  setStage,
  stage,
  setErrors,
  errors,
  handleCheckCommentAutomationValidations,
  isCampagin,
  handleSetAutomationData,
  isAdvanced,
}) {
  const { openDialog, closeDialog, isDialogOpen } = useDialogActionsHook();
  const { credentials } = useSelector((state) => state.instagram);
  const [dmMessageDetails, setDmMessageDetails] = useState(
    automationData.dmMessage || {}
  );
  const [products, setProducts] = useState([]);

  const [dialogComponentKey, setDialogComponentKey] = useState(null);

  const handleGetInitialData = async () => {
    // get products
    const body = {
      instaUserId: credentials.user_id,
      instaId: credentials.id,
    };
    const response = await callNonStoreApi(GetProductsCategoryWise, body);
    setProducts(response.data.products);
  };

  useEffect(() => {
    handleGetInitialData();
  }, []);

  useEffect(() => {
    handleSetAutomationData("dmMessage", dmMessageDetails);
  }, [dmMessageDetails]);

  const getDialogComponent = () => {
    switch (dialogComponentKey) {
      case "products": {
        return (
          <ProductCataloguePopup
            products={products}
            setSelectedProducts={(products) => {
              setDmMessageDetails((prev) => ({ ...prev, products }));
            }}
            selectedProducts={dmMessageDetails.products}
            hideCategoryViewOption={true}
            onClose={() => {
              setDialogComponentKey(null);
              closeDialog();
            }}
          />
        );
      }
      case "advanceReply": {
        return (
          <AdvancedKeywordResponses
            products={products}
            keywords={
              automationData?.keywords.keywords
                ? ["Default", ...automationData?.keywords.keywords]
                : ["Default"]
            }
            dmMessage={automationData.dmMessage?.data}
            closeDialog={() => {
              setDialogComponentKey(null);
              closeDialog();
            }}
            handleSetAutomationData={handleSetAutomationData}
          />
        );
      }
    }
  };
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Segmented: {
              itemColor: "black",
            },
          },
        }}
      >
        <AddFlex flexDirection="column" gap="10px">
          <AddFlex flexDirection="column" gap="5px" alignItems="flex-start">
            <CustomText fontSize="20px" color="black" fontWeight="700">
              Then they'll get the DM.
            </CustomText>
            <Segmented
              shape="round"
              size="medium"
              value={dmMessageDetails.type || "message"}
              options={[
                {
                  label: "Message",
                  value: "message",
                  icon: <MessageOutlined />,
                },
                {
                  label: "Products",
                  value: "products",
                  icon: <ProductOutlined />,
                },
              ]}
              onChange={(value) => {
                if (disabled) return;
                const details = { type: value };
                if (value === "products") {
                  details.products = {
                    type: "products",
                    data: [],
                  };
                }
                setDmMessageDetails(details);
              }}
            />
          </AddFlex>
          {errors["dmMessageMessage"] && (
            <CustomText color="red" fontSize="14px">
              {errors["dmMessageMessage"]}
            </CustomText>
          )}
          {automationData.dmMessage.isAdvanced ? (
            <AddFlex gap="5px" flexDirection="column">
              <CustomText fontSize="16px" fontWeight="500">
                You have set responses for{" "}
                {
                  Object.keys(automationData.dmMessage.data).filter(
                    (word) => word !== "default"
                  ).length
                }{" "}
                word(s)
              </CustomText>
              <Button
                disabled={disabled}
                onClick={() => {
                  setDialogComponentKey("advanceReply");
                  openDialog();
                }}
                style={{ width: "max-content" }}
              >
                Update Advanced Replies
              </Button>
              <Button
                onClick={() => {
                  handleSetAutomationData("dmMessage", {});
                }}
                disabled={disabled}
                style={{ width: "max-content" }}
              >
                Set a generic reply
              </Button>
            </AddFlex>
          ) : (
            <>
              {dmMessageDetails.type === "products" ? (
                <>
                  <AddFlex
                    padding="20px"
                    flexDirection="column"
                    gap="2px"
                    backgroundColor={primaryActionColorLight}
                    border={`2px dashed ${primaryActionColor}`}
                    borderRadius="12px"
                    onClick={() => {
                      setDialogComponentKey("products");
                      openDialog();
                    }}
                  >
                    <CustomText fontSize="14px" color={primaryActionColor}>
                      Click to Add Products
                    </CustomText>
                    {!isArrayNullOrUndefined(
                      dmMessageDetails.products.data
                    ) && (
                      <CustomText fontSize="14px" color={primaryActionColor}>
                        {dmMessageDetails.products.data.length} Product(s) Added
                      </CustomText>
                    )}
                  </AddFlex>
                </>
              ) : (
                <>
                  <CustomTextArea
                    value={dmMessageDetails.message}
                    disabled={disabled}
                    placeholder={"Customise your message."}
                    style={{ backgroundColor: "#f6f7f9" }}
                    onChange={(text) => {
                      setDmMessageDetails((prev) => ({
                        ...prev,
                        message: text,
                      }));
                    }}
                    footerTextColor={"red"}
                    footerText={errors["dmMessageMessage"]}
                  />
                  <CustomInput
                    value={dmMessageDetails.link}
                    disabled={disabled}
                    placeholder={"Add the link"}
                    backgroundColor="#f6f7f9"
                    onChange={(text) => {
                      setDmMessageDetails((prev) => ({ ...prev, link: text }));
                    }}
                    footerTextColor={"red"}
                    footerText={errors["dmMessageLink"]}
                    borderColor={"transparent"}
                  />
                  <CustomInput
                    value={dmMessageDetails.buttonText}
                    disabled={disabled}
                    placeholder={"Customise the button text."}
                    backgroundColor="#f6f7f9"
                    onChange={(text) => {
                      setDmMessageDetails((prev) => ({
                        ...prev,
                        buttonText: text,
                      }));
                    }}
                    footerTextColor={"red"}
                    footerText={errors["dmMessageButtonText"]}
                    borderColor={"transparent"}
                  />
                </>
              )}
              <AddFlex gap="10px">
                {!isEdit && stage <= 3 && (
                  <Button
                    onClick={() => {
                      const errors = handleCheckCommentAutomationValidations(
                        automationData,
                        3,
                        isCampagin
                      );
                      if (Object.keys(errors).length === 0) {
                        setStage(5);
                        setErrors(errors);
                      } else {
                        setErrors(errors);
                      }
                    }}
                    variant="primary"
                    style={{
                      width: "max-content",
                      color: "white",
                      backgroundColor: primaryActionColor,
                    }}
                  >
                    Next
                  </Button>
                )}
                {automationData.keywords.type !== "any" && (
                  <Button
                    disabled={disabled}
                    onClick={() => {
                      setDialogComponentKey("advanceReply");
                      openDialog();
                    }}
                  >
                    Advance Reply Setup
                  </Button>
                )}
              </AddFlex>
            </>
          )}
        </AddFlex>

        <DialogWrapper
          open={isDialogOpen}
          closeDialog={closeDialog}
          width={"50vw"}
          height={"70vh"}
          component={getDialogComponent()}
        />
      </ConfigProvider>
    </>
  );
}

export default InstaCommentToDMAutomationMessage;
